// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3Aovk","footer":"Form_footer__37uN1"};